export default "__VITE_ASSET__DdJ0k5EW__"